export default __webpack_public_path__ + "static/media/thumbnail_1.903895a0.webp";